export const calculateSeatOffsets = (
  event: MouseEvent,
  selectedDots: Record<string, any>,
  data: any
) => {
  const offsets: { [key: string]: { x: number; y: number } } = {};

  for (const key of Object.keys(selectedDots)) {
    const dot = data.data[selectedDots[key]];
    if (dot?.rect) {
      offsets[`seat:${selectedDots[key]}`] = {
        x: event.clientX - Number(dot.rect.x),
        y: event.clientY - Number(dot.rect.y),
      };
    }
  }

  return offsets;
};

export const calculateTextFigureOffsets = (
  event: MouseEvent,
  selectedTextFigures: Record<string, any>,
  data: any
) => {
  const offsets: { [key: string]: { x: number; y: number } } = {};

  for (const key of Object.keys(selectedTextFigures)) {
    const index = selectedTextFigures[key].split(":")[1];
    const figure = data.properties.text?.[index];

    if (figure?.rect) {
      if (figure.properties.type === "polyline") {
        const points = figure.rect.points.split(" ").map((point: string) => {
          const [x, y] = point.split(",").map(Number);
          return { x, y };
        });

        if (points.length > 0) {
          offsets[`text:${index}`] = {
            x: event.clientX - points[0].x,
            y: event.clientY - points[0].y,
          };
        }
      } else {
        offsets[`text:${index}`] = {
          x: event.clientX - Number(figure.rect.x),
          y: event.clientY - Number(figure.rect.y),
        };
      }
    }
  }

  return offsets;
};

export const calculateFanZoneOffsets = (
  event: MouseEvent,
  selectedFanZones: Record<string, any>,
  data: any
) => {
  const offsets: { [key: string]: { x: number; y: number } } = {};
  for (const key of Object.keys(selectedFanZones)) {
    const index = Number(selectedFanZones[key].split(":")[1].split("-")[1]);
    const fanZone = data.hall_parts_data[index];
    const rect = fanZone?.properties?.rectangle?.rect;

    if (rect && rect.x != null && rect.y != null) {
      offsets[`fz:${index}`] = {
        x: event.clientX - Number(rect.x),
        y: event.clientY - Number(rect.y),
      };
    }
  }

  return offsets;
};
